import type { RootState } from 'src/store';

/**
 * Gets organization data from redux store
 * @param state
 * @returns Record<string, string>
 */
export const getOrganization = (state: RootState) => state.organization;
